import { Card } from "primereact/card";
import styled from "styled-components";

export const CVEditStyledCard = styled(Card as any)`
  &.cve-container {
    // responsive start

    &.cve-s,
    &.cve-m {
      .cvp-step-button-text {
        display: none;
      }

      .cve-main-header {
        padding: 0.75rem 0.75rem 0 0.75rem;
      }

      .p-card-body {
        padding: 0 0.75rem;
      }

      .cve-steps-container {
        margin-left: 0.75rem;
        padding-left: 0.75rem;
      }

      .cve-button-bar-placeholder {
        margin-left: -1rem;
      }
    }

    &.cve-l {
      .cvp-step-button-number {
        display: none;
      }
    }

    // responsive end

    .cve-button-bar-placeholder {
      margin-top: 0;
      margin-left: -1.25rem;
    }

    .cve-main-header-subtext {
      background: var(--surface-100);
      border: 1px solid var(--surface-200);
      border-radius: 3px;
      margin: 0.5rem 0;
      padding: 0.25rem 0.5rem;
      box-sizing: border-box;
    }

    .cve-subtext-link {
      color: inherit;
      text-decoration: underline;
      cursor: pointer;
    }

    .cve-main-header-subtext-important {
      background: var(--yellow-100);
      border: 1px solid var(--yellow-300);
    }

    .cve-already-applied-tag {
      padding: 0.25rem 0.5rem;
      font-size: 1em;
      font-weight: normal;
      border-radius: 4px;
      margin-top: 1rem;
    }

    .cve-empty-list-placeholder {
      background: var(--surface-100);
      border: none;
      padding: 0.5rem;
      border-radius: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-grow: 1;
      height: 100px;

      &:hover,
      &:active,
      &:focus {
        border-radius: 3px;
      }

      .p-button-label,
      .p-treeselect-label-container,
      .p-multiselect-label-container {
        flex-grow: 0;
      }
    }

    .cve-separator {
      margin-bottom: 1.5rem;
      height: 2px;
      background: var(--primary-color);
    }

    .cve-main-header {
      position: relative;
      padding: 1.5rem 1.5rem 0 1.5rem;

      .cvp-h1,
      .cvp-h2,
      .cvp-h3 {
        margin: 0;
      }
    }

    .cve-x-editor {
      .cve-smaller-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
    }

    .cve-steps-and-buttons-container {
      flex-grow: 1;
      max-width: 100%;
      min-width: 0;
    }

    .cve-already-applied-content {
      height: 300px;
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    .cve-already-applied-subtext {
      margin-top: 1rem;
      text-align: center;
    }

    .cve-already-applied-badge.p-tag {
      margin-top: 1rem;
      padding: 0.5rem 0.75rem;
      font-size: 1em;
      font-weight: normal;
      border-radius: 4px;

      margin-bottom: 1rem;

      .p-tag-icon {
        font-size: 1em;
      }
    }

    .cve-content {
      display: flex;
    }

    .cve-steps {
      flex-direction: column;
      margin-top: 0.25rem;
    }

    .cve-steps-container {
      margin-left: 1rem;
      padding-left: 1rem;
      border-left: 1px solid var(--surface-500);
      min-height: 250px;
      display: flex;
      flex-direction: column;
    }

    .cve-working-here-now-checkbox {
      display: flex;

      .p-checkbox {
        order: -1;
        margin-right: 0.5rem;
      }
    }

    .cve-next-step-button {
      flex-grow: 0;
      flex-basis: auto;
    }

    .cve-apply-for-position-button {
      flex-grow: 0;
      flex-basis: auto;
    }

    .cve-button-bar {
      justify-content: flex-end;
      margin-top: 0.5rem;

      .ws-form-grid {
        justify-content: flex-end;
      }
    }

    .cve-main-button-bar {
      margin-top: 2rem;
    }

    .cve-disabled-datefield-input {
      background: var(--surface-200);
    }

    .p-card {
      display: flex;
      flex-direction: column;
    }

    .p-card-content {
      > .ws-form-grid:first-child {
        margin-top: 0;
      }
    }

    .cve-smaller-header {
      font-size: 1.15em;
    }

    .cve-header.cve-header {
      font-weight: 600;
      font-size: 1.5em;

      margin-top: 2rem;
    }

    .ws-form-grid:first-child {
      > .cve-header.cve-header:first-child {
        margin-top: 0.25rem;
      }
      > :first-child {
        > .cve-header.cve-header:first-child {
          margin-top: 0.25rem;
        }
      }
    }

    .p-card-body {
      width: 100%;
    }

    .p-inputtext {
      width: 100%;
    }
  }
`;
